
import Util from "@/ts/Util";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    HeaderColor,
  },
})
export default class About extends Vue {
  appVersion = process.env.VUE_APP_VERSION || "N/A";

  backButton = {
    show: true,
    callback: this.goBack,
  };

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
  }

  goBack() {
    this.$router.go(-1);
  }
}
